import { FunctionComponent } from 'react'
import styles from './Header.module.css'

const Header: FunctionComponent = () => {
  return (
    <header className={styles.vectorParent}>
      <a href="/" style={{ flexShrink: 0 }}>
        <img className={styles.vectorIcon} loading="eager" alt="" src="/vector.svg" />
      </a>
      <a className={styles.fRAME} href="/contact">
        <div className={styles.contactUs}>Contact us</div>
        <img
          className={styles.arrowOutwardFill0Wght400GrIcon}
          alt=""
          src="/arrow-outward-fill0-wght400-grad0-opsz20-1.svg"
        />
      </a>
    </header>
  )
}

export default Header
